import { Component, Input, OnChanges } from '@angular/core';
import { ComponentData, TabData, TabUtil } from '@ddt-web/data-service';
import { IHighChartsAttributesModel } from '@ddt-web/highchart-manager';

@Component({
	selector: 'mb-model-allocation-chart',
	templateUrl: './model-allocation-chart.component.html',
	styleUrls: ['./model-allocation-chart.component.scss']
})
export class ModelAllocationChartComponent implements OnChanges {

	@Input() public data: ComponentData;

	public allocationChartData: TabData = {} as TabData;
	public highChartAttributes: IHighChartsAttributesModel = {
		width: 150,
		height: 150,
		chartType: 'doughnut',
		tabData: this.allocationChartData,
		portfolioIndex: 0,
		tooltipType: 'category-point'
	};

	public ngOnChanges(): void {
		if (TabUtil.isDataAvailable(this.data, 'holdings.chart')) {
			this.allocationChartData = this.data.getTabById('holdings.chart');
			this.highChartAttributes.tabData = this.allocationChartData;
		}
	}

}
